export const GET_RELATIVES = 'GET_RELATIVES';
export const LOADING_RELATIVES = 'LOADING_RELATIVES';
export const SAVE_LOADER_RELATIVES = 'SAVE_LOADER_RELATIVES';
